/**
 * This helper function is to help trace the path of an event.
 * Some framework like lit retarget events from a shadowRoot element has
 * it was triggered by the host itself which is sometimes ok but maybe not
 * as a default behaviour...
 * https://lit-element.polymer-project.org/guide/events#event-retargeting
 */
export const getHostChildsFromEvent = (event, host) => {
    const elements = event.composedPath();
    return elements.reduce((acc, el) => {
        return el.nodeName && host.contains(el) ? [...acc, el] : acc;
    }, []);
};
export const isPointOverRect = (bounds, point) => {
    if (point.x >= bounds.left &&
        point.x <= bounds.left + bounds.width &&
        point.y >= bounds.top &&
        point.y <= bounds.top + bounds.height) {
        return true;
    }
    return false;
};
export const inflateRect = (rect, value) => {
    return Object.assign(Object.assign({}, rect), { top: rect.top - value, left: rect.left - value, width: rect.width + value * 2, height: rect.height + value * 2 });
};
export const getTabbableChildren = (element) => element.querySelectorAll('[tabindex]:not([tabindex="-1"])');
/**
 * Finds the closest theme provider to the provided baseElement going up the DOM.
 * This is necessary because simply calling .closest() does not go through the shadow-root
 */
export const findClosestThemeProvider = (baseElement) => {
    if (!baseElement) {
        const provider = document.querySelector('chameleon-theme-provider');
        return provider !== null && provider !== void 0 ? provider : undefined;
    }
    const provider = baseElement.closest('chameleon-theme-provider');
    if (provider) {
        return provider;
    }
    else {
        return findClosestThemeProvider(baseElement.getRootNode().host);
    }
};
